var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_loading)?_c('Loading'):_vm._l((_vm.posts),function(post){return _c('PostListItem',{key:post.id,attrs:{"post":post.attributes}})}),(!_vm.is_loading && _vm.posts.length < 1)?_c('p',{staticClass:"text-center"},[_vm._v(" No discussion found. ")]):_vm._e(),(_vm.scrolledToBottom)?_c('Loading',{staticClass:"border mt-3"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }